<template lang="pug">
    v-layout(wrap class="my-3 pl-2")
        v-flex(xs12 class="my-3")
            e-typography-heading-2 {{item.title}}

        v-flex(xs12)
            m-form-risk-assessment-notice(v-on="$listeners" :answer="answers" :raId="raId")

        v-flex(xs12 class="mt-3")
            e-divider-secondary

        v-flex(xs12 class="mt-1")
            m-block-question-links(v-on="$listeners")
</template>

<script>
    import MFormRiskAssessmentNotice from "@modules/forms/concrete/risk-assessment/m-form-risk-assessment-notice";
    import MBlockQuestionLinks from "@modules/blocks/links/concrete/m-block-question-links";

    let name = 'm-block-ra-notice';
    export default {
        name: name,
        components: {MBlockQuestionLinks, MFormRiskAssessmentNotice},
        props: {
            name: {
                type: String,
                default: name
            },
            item: {
                type: Object,
                required: true
            },
            answers: {
                type: Object
            },
            raId: {
                type: String,
                required: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    //
</style>
